import HeaderProgress from '../../create-proposal/common/header-progress'
import { Spinner } from '../../../../assets/icon/svg'
import { useDispatch, useSelector } from 'react-redux'
import { clearUpdateTypeModal } from '../../../../features/gms-state-and-modal/modal-slice'
import { useCreateProposalForm } from '../../../../hooks/actions/use-create-proposal-form'
import { useModalInfo } from '../../../../hooks/common/use-modal-info'
import FirstStep from '../../create-proposal/steps/first-step/first-step'
import SecondStep from '../../create-proposal/steps/second-step/second-step'
import ThirdStep from '../../create-proposal/steps/third-step/third-step'
import FourthStep from '../../create-proposal/steps/fourth-step/fourth-step'
import { useProposalData } from '../../../../hooks/populate-data/use-proposal-data'
import CloseButtonModal from '../../../ui/close-button-modal'
import { resetCsvFile } from '../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice'
import { clearFiles } from '../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice'
import { selectCurrentStep, setCurrentStep } from '../../../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice'
import ConfirmDefaultModal from '../../../global/modal/confirm-default-modal'
import { selectAmendmentModalOne } from '../../../../features/actuarial/request-amendment/request-amendment.slice'
import { useEffect, useRef } from 'react'

export default function UpdateProposal() {
    
    const dispatch = useDispatch();
    const currentStep = useSelector(selectCurrentStep)
    const amendmentModalOne = useSelector(selectAmendmentModalOne)
    const { 
        proposal,
        isLoadingProposal,
        isErrorProposal,
        proposalErrorMessage,
        repopulateAll,
        repopulateRates,
        populateRequestAmendment,
        populateProposalActuarialFiles,
        populateProposalNotesForCFE,
    } = useProposalData()
    const {
        isSaveProposal, 
        setIsSaveProposal, 
        handleSaveClientData, 
        handleSubmitProposal, 
        isLoading, 
        submitType,
        isLoadingCreateProposal,
        isLoadingUploadMasterCSVFile,
        isLoadingUpdateProposal,
        isLoadingCreateProposalAsDraft,
        isLoadingSaveSupportingDocuments
    } = useCreateProposalForm();
    
    const isLoadingAPI = 
        isLoadingCreateProposal || 
        isLoadingUploadMasterCSVFile || 
        isLoadingUpdateProposal || 
        isLoadingCreateProposalAsDraft || 
        isLoadingSaveSupportingDocuments

    const { modalTitle, modalSubTitle } = useModalInfo(submitType);

    /*
    |--------------------------------------------------------------------------
    | FULL PROPOSAL POPULATION
    |--------------------------------------------------------------------------
    |
    | This runs only when UpdateProposal is mounted and the proposal is ready.
    | The complete proposal, rates, and amendment-related data are populated.
    | - Populate only once for the currently opened proposal
    |--------------------------------------------------------------------------
    */
    const populatedProposalIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (!proposal?.application_id) {
            return;
        }

        if (populatedProposalIdRef.current === proposal.application_id) {
            return;
        }

        populatedProposalIdRef.current = proposal.application_id;

        repopulateAll();
    }, [
        proposal?.application_id,
        repopulateAll,
    ]);

    
    const handleCloseUpdateProposalModal = async () => {
        if(amendmentModalOne === 'isRequesting') {
            populateProposalActuarialFiles();
            populateProposalNotesForCFE();
            repopulateAll();
            dispatch(clearUpdateTypeModal());
            dispatch(setCurrentStep(1));
            return;
        }

        dispatch(resetCsvFile());
        dispatch(clearUpdateTypeModal());
        dispatch(setCurrentStep(1));
        dispatch(clearFiles());
        repopulateAll();
    }

    return (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-start z-50 p-4">
            <div className="h-[96dvh] w-full bg-[#f5f9fd] rounded overflow-hidden shadow my-auto flex flex-col sm:h-[90dvh] sm:max-w-[95vw] lg:max-w-[700px] xl:max-w-[1000px] 2xl:max-w-[1100px]">
                {isLoadingProposal ? (
                    <div className='min-h-[400px] flex justify-center items-center'>
                        <div className="flex justify-center items-center h-full w-full">
                            <Spinner color={'#186cb2'} size={40} />
                            <span className='ml-[5px]'>Loading...</span>
                        </div>
                    </div>
                ) : isErrorProposal ? (
                    <div className='min-h-[400px] flex justify-center items-center'>
                        <div className="flex justify-center items-center h-full w-full">
                            <p className='text-black text-xs'>{proposalErrorMessage}</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="sticky border-b top-0 z-20 px-6 py-5 shadow bg-white flex flex-col space-y-2 justify-between items-center ">
                            <div className="w-full flex justify-between items-center">
                                <div className="items-start">
                                    <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                        Update Proposal
                                    </p>
                                </div>
                                <div className="flex justify-end items-center">
                                    <CloseButtonModal handleClose={handleCloseUpdateProposalModal}/>
                                </div>
                            </div>
                            <hr className="h-px bg-gray-200 border-0" />
                            <div className='w-full'>
                                <HeaderProgress handleSaveClientData={handleSaveClientData} hasDraft={true} />
                            </div>
                        </div>
                        <div className='px-5 py-4 overflow-y-auto flex-1 space-y-2'>
                            {currentStep === 1 && (<FirstStep isRenewal={false} />)}
                            {currentStep === 2 && (<SecondStep/>)}
                            {currentStep === 3 && (<ThirdStep/>)}
                            {currentStep === 4 && (<FourthStep/>)}
                        </div>
                    </>
                )}
                {isSaveProposal && (
                    <ConfirmDefaultModal
                        onCancel={() => setIsSaveProposal(false)}
                        onConfirm={handleSubmitProposal}
                        modalTitle={modalTitle}
                        modalSubTitle={modalSubTitle}
                        isLoading={isLoadingAPI}
                    />
                )}
            </div>
        </div>
    )
}